import GqlFullCrudTree from './GqlFullCrudTree';
export default GqlFullCrudTree;
